if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.skuEl = this.form.querySelector('[name=sku]');
      if (this.skuEl) {
        this.sku = this.skuEl.value;
        this.checkProductAvailability();
        subscribe(PUB_SUB_EVENTS.deliveryLocationUpdate, this.checkProductAvailability.bind(this));
      }
    }

    checkProductAvailability() {
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));
      if (!deliveryLocation) {
        this.submitButton.disabled = false;
        this.submitButton.querySelector('span').textContent = gopuffShopify.strings.check_availability;
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      };

      const params = {
        country_code: deliveryLocation.delivery_zone.country_code,
        location_id: deliveryLocation.delivery_zone.id,
        product_ids: this.sku,
      };

      fetch(`${window.gopuffShopify.settings.api_base_url}/products?${new URLSearchParams(params)}`)
        .then((response) => response.json())
        .then((response) => {
          if (response.products) {
            response.products.forEach((product) => {
              this.setInventoryLimit(product.quantity)
            });

            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        })
        .catch((e) => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          console.error(e);
        });
    }

    setInventoryLimit(quantity) {
      const instock = quantity > 0;
      if (gopuffShopify.settings.show_inventory_quantity) {
        document.querySelector(`.quantity__rules`).textContent = gopuffShopify.strings.inventory_in_stock_show_count.replace('{{ quantity }}', quantity);
      }
      if (instock) {
        this.submitButton.disabled = false;
        this.submitButton.querySelector('span').textContent = variantStrings.addToCart;
      }
      else {
        this.submitButton.disabled = true;
        this.submitButton.querySelector('span').textContent = variantStrings.soldOut;
      }

      const quantityInput = this.parentElement.parentElement.querySelector('quantity-input');
      if (quantityInput) {
        const cartQuantity = Number(quantityInput.input.dataset.cartQuantity);
        const maxQuantity = quantity - cartQuantity
        if (maxQuantity > 0) {
          quantityInput.setMax(maxQuantity);
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));
      if (!deliveryLocation) {
        document.querySelector('location-modal').showModal();
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
